import type { Plugins } from 'core/plugins/config/types';
import { requiredPluginsExist } from 'core/plugins/model/required-plugins-exist';

/**
 * Return a map of plugins that can be loaded (all required modules are present).
 */
export function getMapOfLoadablePlugins(
  newPlugins: Map<string, Plugins.Model>,
  loadedPlugins: Map<string, Plugins.Model> = new Map(),
): Map<string, Plugins.Model> {
  return getLoadablePlugins(newPlugins, loadedPlugins, new Map());
}

/**
 * Get loadable plugins.
 */
function getLoadablePlugins(
  newPlugins: Map<string, Plugins.Model>,
  loadedPlugins: Map<string, Plugins.Model>,
  resultPlugins: Map<string, Plugins.Model>,
) {
  if (newPlugins.size === 0) {
    return resultPlugins;
  }

  const newPluginsCountBefore = newPlugins.size;
  const availablePlugins = new Map([...loadedPlugins.entries(), ...resultPlugins.entries()]);

  newPlugins.forEach((plugin) => {
    const canPluginBeLoaded = requiredPluginsExist(plugin.requires, availablePlugins);

    if (canPluginBeLoaded) {
      resultPlugins.set(plugin.name, plugin);
      newPlugins.delete(plugin.name);
    }
  });

  if (newPluginsCountBefore === newPlugins.size) {
    resultPlugins.clear();

    return resultPlugins;
  }

  return getLoadablePlugins(newPlugins, loadedPlugins, resultPlugins);
}
